import { render, staticRenderFns } from "./SmartcardItsmeDeactivation.vue?vue&type=template&id=5a1e6c37&scoped=true"
import script from "./SmartcardItsmeDeactivation.vue?vue&type=script&lang=js"
export * from "./SmartcardItsmeDeactivation.vue?vue&type=script&lang=js"
import style0 from "./SmartcardItsmeDeactivation.vue?vue&type=style&index=0&id=5a1e6c37&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1e6c37",
  null
  
)

export default component.exports